import { motion } from "framer-motion";
import { Mail, MapPin, ShieldCheck } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { CONTACT } from "../../lib/i18n";
import { Reveal } from "./Motion";
import { ContactForm } from "./ContactForm";
import { EASE } from "../../lib/scroll";

const Item = ({ icon: Icon, label, children, testid }) => (
  <div className="flex gap-5 border-t border-white/10 py-6" data-testid={testid}>
    <Icon className="mt-1 h-5 w-5 shrink-0 text-[#e8c979]" strokeWidth={1.5} />
    <div>
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/40">{label}</p>
      <div className="mt-2 text-base text-white/85">{children}</div>
    </div>
  </div>
);

export const Contact = () => {
  const { t, lang } = useLang();
  const c = t.contact;
  return (
    <section id="contatti" data-testid="contact-section" className="grain relative overflow-hidden bg-[#0a0a0b] py-28 text-[#fafaf7] md:py-40">
      <div className="pointer-events-none absolute -bottom-60 right-[-10%] h-[700px] w-[700px] rounded-full bg-[#d4af37]/10 blur-[160px]" />
      <div className="wrap relative">
        <p className="eyebrow mb-10">{c.eyebrow}</p>
        <h2 className="font-display text-5xl font-bold leading-[0.98] tracking-[-0.03em] sm:text-7xl lg:text-[7rem]">
          {c.title.map((l, i) => (
            <span key={`${lang}-${i}`} className="block overflow-hidden pb-[0.05em]">
              <motion.span
                className={`block ${i === 1 ? "font-serif-i gold-text font-normal" : ""}`}
                initial={{ y: "110%" }}
                whileInView={{ y: "0%" }}
                viewport={{ once: true }}
                transition={{ duration: 1.2, ease: EASE, delay: i * 0.12 }}
              >
                {l}
              </motion.span>
            </span>
          ))}
        </h2>
        <div className="mt-20 grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <p className="mb-10 max-w-md text-base leading-relaxed text-white/60 md:text-lg">{c.sub}</p>
            <Item icon={Mail} label={c.email} testid="contact-email">
              <a href={`mailto:${CONTACT.email}`} className="transition-colors hover:text-[#e8c979]">{CONTACT.email}</a>
            </Item>
            <Item icon={MapPin} label={c.hq} testid="contact-address">{c.address}</Item>
            <Item icon={ShieldCheck} label={c.pec} testid="contact-pec">
              <a href={`mailto:${CONTACT.pec}`} className="break-all transition-colors hover:text-[#e8c979]">{CONTACT.pec}</a>
            </Item>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-7">
            <div className="rounded-[32px] border border-white/10 bg-white/[0.03] p-8 backdrop-blur-xl md:p-12">
              <ContactForm type="project" prefix="contact" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
